<template>
  <v-container fluid grid-list-md>
    <v-flex pb-0>
      <v-text-field
        label="Group Name"
        v-model="ag.name"
        :outlined="outlinedInputs"
      ></v-text-field>
    </v-flex>
    <v-container fluid grid-list-md class="pa-0">
      <v-row>
        <v-col class="flex-grow-1">
          <v-card class="fullSizeCard">
            <v-flex xs12 sm12>
              <h1 class="subtitle-1 pt-2">Available Agents</h1>
            </v-flex>
            <v-flex xs12 sm12 class="pb-2">
              <v-text-field
                append-icon="mdi-magnify"
                label="Quick Filter..."
                single-line
                hide-details
                v-model="searchAvailableAgents"
                class="ma-0 pt-0"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-flex>
            <v-layout column style="height: 50vh">
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers"
                  :items="availableAgents"
                  :search="searchAvailableAgents"
                  :loading="$apollo.loading"
                  item-key="id"
                  v-bind="pagingOptions"
                  v-model="availableAgentsSelected"
                  show-select
                ></v-data-table>
              </v-flex>
            </v-layout>
          </v-card>
        </v-col>
        <v-col
          style="flex: 0 0 60px"
          class="d-flex align-center justify-center flex-column"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                small
                fab
                color="success"
                @click="addToGroup"
                v-on="on"
                :disabled="addButtonDisabled"
                class="mb-2"
              >
                <v-icon dark>mdi-arrow-right</v-icon>
              </v-btn>
            </template>
            <span>Add To Group</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                fab
                color="error"
                @click="removeFromGroup"
                :disabled="removeButtonDisabled"
              >
                <v-icon dark>mdi-arrow-left</v-icon>
              </v-btn>
            </template>
            <span>Remove From Group</span>
          </v-tooltip>
        </v-col>
        <v-col class="flex-grow-1">
          <v-card class="fullSizeCard">
            <v-flex xs12 sm12>
              <h1 class="subtitle-1 pt-2">Agents In Group</h1>
            </v-flex>
            <v-flex xs12 sm12 class="pb-2">
              <v-text-field
                append-icon="mdi-magnify"
                label="Quick Filter..."
                single-line
                hide-details
                v-model="searchGroupAgents"
                class="ma-0 pt-0"
                :outlined="outlinedInputs"
              ></v-text-field>
            </v-flex>
            <v-layout column style="height: 50vh">
              <v-flex style="overflow: auto">
                <v-data-table
                  :headers="headers"
                  :items="groupAgentsArray"
                  v-bind="pagingOptions"
                  :search="searchGroupAgents"
                  item-key="id"
                  v-model="groupAgentsSelected"
                  show-select
                ></v-data-table>
              </v-flex>
            </v-layout>
          </v-card>
        </v-col>
      </v-row>
      <v-layout row wrap>
        <v-flex sm6>
          <v-checkbox
            label="Not In Use"
            v-model="ag.notInUse"
            primary
            hide-details
          ></v-checkbox>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import {
  AGENT_GROUP_UPDATE_MUTATION,
  AGENT_GROUP_CREATE_MUTATION,
  AGENT_GROUP_SEARCH_QUERY,
} from "../../../constants/graphql";
import { pagingOptions, removeGQLTypename } from "../../../helpers/index";
const ALL_AGENTS = gql`
  query allAgents {
    agents(first: 4000, filter: { not_in_use_eq: false }) {
      totalCount
      edges {
        node {
          id
          name
          companyCode
          department
          email
          address
        }
      }
    }
  }
`;
export default {
  name: "AgentGroupEditor",

  props: {
    selectedAgentGroup: {
      type: Object,
      default: () => ({}),
    },

    doSaveAgentGroup: {
      type: Boolean,
      default: false,
    },

    agentGroupEditorDialog: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      debug: false,
      pagingOptions,
      agentGroup: {},
      agents: {},
      ag: {
        id: "",
        name: "",
        notInUse: false,
        agentIds: [],
      },
      groupAgentsArray: [],
      searchAvailableAgents: "",
      searchGroupAgents: "",
      agentGroupId: "",
      skipAgentGroup: true,
      addButtonDisabled: true,
      removeButtonDisabled: true,
      availableAgentsSearch: "",
      groupAgentsSearch: "",
      groupName: "",
      headers: [
        {
          text: "Name",
          align: "left",
          value: "name",
          name: "name",
        },
        {
          text: "Company Code",
          align: "left",
          value: "companyCode",
          name: "companyCode",
        },
      ],
      availableAgentsSelected: [],
      groupAgentsSelected: [],
    };
  },

  methods: {
    saveAgentGroup() {
      let mutation =
        this.context == "edit"
          ? AGENT_GROUP_UPDATE_MUTATION
          : AGENT_GROUP_CREATE_MUTATION;
      this.fillAgAgentIdsArray();
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: {
            ...this.ag,
          },
        })
        .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
    },
    fillAgAgentIdsArray() {
      for (let i = 0; i < this.groupAgentsArray.length; i++) {
        this.ag.agentIds.push(this.groupAgentsArray[i].id);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
    addToGroup() {
      for (let i = 0; i < this.availableAgentsSelected.length; i++) {
        this.groupAgentsArray.push(this.availableAgentsSelected[i]);
      }

      this.availableAgentsSelected = [];
    },
    removeFromGroup() {
      this.groupAgentsArray = this.groupAgentsArray.filter(
        (a) => this.groupAgentsSelected.indexOf(a) == -1
      );

      this.groupAgentsSelected = [];
    },

    setSaveButton() {
      if (this.ag.name != "" && this.groupAgentsArray.length != 0) {
        this.$emit("enableSaveButton");
      } else {
        this.$emit("disableSaveButton");
      }
    },
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    agentGroupLabel() {
      return this.selectedAgentGroup.id != null
        ? this.selectedAgentGroup.name
        : "New Agent Group";
    },
    context() {
      return this.selectedAgentGroup.id != null ? "edit" : "create";
    },
    availableAgents() {
      const agentsInGroup = this.groupAgentsArray.map((a) => a.id);
      return this.agents && this.agents.edges
        ? this.agents.edges
            .map(removeGQLTypename)
            .filter((a) => agentsInGroup.indexOf(a.id) == -1)
        : [];
    },
  },

  watch: {
    agentGroup(data) {
      let agentGroup = { ...data };
      //console.log("agentGroup", data);
      this.groupName = data.name;

      this.ag.id = data.id;
      this.ag.name = data.name;
      this.ag.notInUse = data.notInUse;
      this.ag.agentIds = [];

      let members = agentGroup.members.edges;
      let groupAgentIds = [];

      this.groupAgentsArray = [];

      for (let i = 0; i < members.length; i++) {
        this.groupAgentsArray.push(members[i].node);
        groupAgentIds.push(members[i].node.id);
      }
      groupAgentIds = groupAgentIds.sort();
    },
    agentGroupEditorDialog(value) {
      if (!value) {
        this.groupAgentsArray = [];
        this.groupAgentsSelected = [];
        this.availableAgentsSelected = [];
        this.searchAvailableAgents = "";
        this.searchGroupAgents = "";
        this.ag = {
          id: "",
          name: "",
          notInUse: false,
          agentIds: [],
        };
      }
    },
    doSaveAgentGroup(value) {
      if (value) {
        this.saveAgentGroup();
      }
    },

    ag: {
      handler(data) {
        this.setSaveButton();
      },
      deep: true,
    },
    groupAgentsArray(data) {
      this.setSaveButton();
    },
    availableAgentsSelected(data) {
      this.addButtonDisabled = data.length == 0;
    },
    groupAgentsSelected(data) {
      this.removeButtonDisabled = data.length == 0;
    },
  },

  apollo: {
    agentGroup: {
      query: AGENT_GROUP_SEARCH_QUERY,
      variables() {
        return {
          id: this.selectedAgentGroup.id,
        };
      },
      skip() {
        return this.selectedAgentGroup.id == null;
      },
      fetchPolicy: "network-only",
    },
    agents: {
      query: ALL_AGENTS,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped>
.edge {
}

.middle {
  width: 80px;
  text-align: center;
}

.fullSizeCard {
  min-height: 100%;
  min-width: 100%;
  padding-left: 20px;
  padding-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/agents/AgentGroupEditor.vue